import { type ReactNode } from 'react';

import { Button, AlertDialog, type AlertDialogProps } from '@backyard-ui/core';

import { useProductStore } from '@/presenters/store/catalog/product';

export interface VoltageDialogProps
  extends Pick<AlertDialogProps, 'isOpen' | 'onOpenChange'> {
  onConfirm: () => void;
  children: ReactNode;
}

function VoltageDialog(props: Readonly<VoltageDialogProps>) {
  const { isOpen, onConfirm, onOpenChange, children } = props;

  const { characteristics } = useProductStore((store) => store.product);

  const productVoltage = characteristics?.find(
    (item) => item.name === 'Tensão Elétrica'
  )?.value;

  return (
    <AlertDialog.Root
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="sm"
      isCentered
    >
      <AlertDialog.Trigger asChild>{children}</AlertDialog.Trigger>

      <AlertDialog.Content>
        <AlertDialog.Title>Confirme a voltagem</AlertDialog.Title>

        <AlertDialog.Description>
          O produto selecionado é de <b>{productVoltage}</b>, tem certeza que é
          a voltagem desejada?
        </AlertDialog.Description>

        <AlertDialog.Footer>
          <AlertDialog.Cancel asChild>
            <Button appearance="critical" variant="ghost">
              Não, cancelar
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button onClick={onConfirm}>Sim, confirmar</Button>
          </AlertDialog.Action>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
}

export default VoltageDialog;
